var t=t=>{var{appPathObj:a,url:c}=t,r=a["application.js"],e=document.createElement("script");return e.type="text/javascript",e.async=!0,e.src="".concat(c).concat(r),e};export{t as getChatScript};
//# sourceMappingURL=get-chat-script.js.map
